import { MessageCircle, X, ExternalLink, UserRound, CheckCheck } from "lucide-react";
import { openWhatsAppWeb, useHandle, clientLine, timeAgo, isLate, waitLabel } from "@/components/inbox/inboxUtils";

const Card = ({ t, onHide, onHandled, onOpenClient, extra }) => {
  const { busy, handle } = useHandle(onHandled);
  const late = isLate(t);
  return (
    <div data-testid={`inbound-popup-${t.wa_id}`} data-late={late} className={`pointer-events-auto w-[380px] max-w-[calc(100vw-2rem)] rounded-2xl border ${late ? "border-red-500/70 shadow-red-900/40" : "border-emerald-500/40"} bg-[#0F141F]/95 p-4 max-sm:p-3 shadow-2xl shadow-emerald-900/40 backdrop-blur-xl fade-up`}>
      <div className="flex items-start gap-3">
        <span className="relative mt-0.5 rounded-xl bg-emerald-500/15 p-2">
          <MessageCircle className="h-5 w-5 text-[#25D366]" />
          <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 animate-ping rounded-full bg-emerald-400" />
        </span>
        <div className="min-w-0 flex-1">
          <div className={`text-[11px] font-semibold uppercase tracking-wider ${late ? "text-red-400" : "text-emerald-300"}`}>{late ? "Sem atendimento · prioridade" : "Cliente respondeu no Financeiro"}</div>
          <div data-testid="inbound-popup-name" className="truncate text-base font-bold text-white">{t.client?.name || t.phone}</div>
          <div className="truncate text-xs text-slate-400">{t.phone} · {clientLine(t.client)}</div>
        </div>
        <button data-testid="inbound-popup-close" onClick={() => onHide(t)} title="Esconder até a próxima mensagem" className="rounded-lg p-1 text-slate-500 transition-colors hover:bg-[#1A2234] hover:text-slate-200">
          <X className="h-4 w-4" />
        </button>
      </div>
      <div data-testid="inbound-popup-text" className="mt-3 line-clamp-3 break-words rounded-xl border border-[#1F293D] bg-[#111827] px-3 py-2 text-sm text-slate-200 sm:line-clamp-none">
        “{t.last_text}”
        <div className="mt-1 text-[11px] text-slate-500">{timeAgo(t.last_at)}{t.count > 1 ? ` · ${t.count} mensagens` : ""}
          <span data-testid="inbound-popup-wait" className={`ml-1 ${late ? "font-semibold text-red-400" : ""}`}>· {waitLabel(t)}</span></div>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 max-sm:mt-2">
        <button data-testid="inbound-popup-call" onClick={() => openWhatsAppWeb(t)} className="col-span-2 inline-flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-3 py-2.5 text-sm font-bold text-slate-950 transition-transform hover:-translate-y-0.5">
          <ExternalLink className="h-4 w-4" /> Chamar no WhatsApp Web
        </button>
        <button data-testid="inbound-popup-open-client" disabled={!t.client_id} onClick={() => onOpenClient(t.client_id)} className="inline-flex items-center justify-center gap-1.5 rounded-xl border border-[#1F293D] px-3 py-2 text-xs font-semibold text-slate-300 transition-colors hover:bg-[#1A2234] disabled:opacity-40">
          <UserRound className="h-4 w-4" /> Abrir ficha
        </button>
        <button data-testid="inbound-popup-handled" disabled={busy} onClick={() => handle(t)} className="inline-flex items-center justify-center gap-1.5 rounded-xl border border-emerald-500/40 px-3 py-2 text-xs font-semibold text-emerald-300 transition-colors hover:bg-emerald-500/10 disabled:opacity-50">
          <CheckCheck className="h-4 w-4" /> Atendido
        </button>
      </div>
      {extra > 0 && <div data-testid="inbound-popup-more" className="mt-2 text-center text-[11px] text-slate-400">+{extra} outra(s) conversa(s) pendente(s) em Respostas</div>}
    </div>
  );
};

export const InboundPopup = ({ items: raw, onHide, onHandled, onOpenClient }) => {
  if (!raw.length) return null;
  const items = [...raw.filter(isLate), ...raw.filter((t) => !isLate(t))];
  return (
    <div data-testid="inbound-popup" className="pointer-events-none fixed bottom-4 right-4 z-[60] flex flex-col items-end gap-2">
      <Card t={items[0]} onHide={onHide} onHandled={onHandled} onOpenClient={onOpenClient} extra={items.length - 1} />
    </div>
  );
};
